import {
    FETCH_USER_LIST,
} from '../ActionTypes'

const API_URL = process.env.API_URL

const updateUserList = (json) => {
    return {
        type: FETCH_USER_LIST,
        payload: json
    }
}

export const fetchUserList = (token) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/users`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(json => dispatch(updateUserList(json.result)))
    }
}

export const fetchUser = (token, userId, cb) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/user/${userId}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => cb(json.result))
    }
}

export const addUser = (token, userInfo, cb) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/register`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userInfo)
            })
            .then((res) => res.json())
            .then(json => {
                if (json.success)
                    dispatch(fetchUserList(token))
                cb(json.success)
            })
    }
}

export const updateUser = (token, userId, userInfo, cb) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/user/${userId}`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userInfo)
            })
            .then((res) => res.json())
            .then(json => {
                if (json.success)
                    dispatch(fetchUserList(token))
                cb(json.success)
            })
    }
}

export const removeUsers = (token, userList) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/users`, {
                method: 'DELETE',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ users: userList })
            })
            .then(response => response.json())
            .then(json => dispatch(fetchUserList(token)))
    }
}


// WEBPACK FOOTER //
// ./src/UserManagementPage/UserManagementPageActions.js